import { createFileRoute, redirect } from '@tanstack/react-router';
import { EventsDocument } from 'shared/__generated__/graphql';
import _ from 'lodash';
import { genMeta } from 'web2/app/utils/meta';
import { gql } from 'shared/__generated__/gql';
import EventLanding from './-event-landing';
import { getSessionUser } from 'web2/app/actions/getSessionUser';

gql(/* GraphQL */ `
  query Events(
    $first: Int
    $after: String
    $showPastEvents: Boolean
    $sortByUpcoming: Boolean
    $tags: [String!]
    $query: String
    $startDate: Float
    $endDate: Float
    $collaboratorIds: [String!]
    $amIAttending: Boolean
  ) {
    events(
      first: $first
      after: $after
      showPastEvents: $showPastEvents
      sortByUpcoming: $sortByUpcoming
      tags: $tags
      query: $query
      startDate: $startDate
      endDate: $endDate
      collaboratorIds: $collaboratorIds
      amIAttending: $amIAttending
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          title
          description
          imageUrl
          date
          location
          tags
          slug
          settings {
            inviteOnly
            unlistEvent
          }
          attendeesTotalCount
          attendeesFriendsCount
          myStatus
          collaborators {
            user {
              ...UserCore
            }
          }
        }
      }
    }
  }
`);

export const Route = createFileRoute('/events/')({
  component: RouteComponent,
  head: (_args) => {
    return genMeta({
      title: 'Events | PI.FYI',
      description: 'Browse and discover events on PI.FYI',
      // TODO REMOVE WHEN EVENTS ARE LIVE
      other: [{ name: 'robots', content: 'noindex' }],
    });
  },
  beforeLoad: async () => {
    const user = await getSessionUser();
    if (user?.role !== 'ADMIN' && process.env.NODE_ENV === 'production') {
      throw redirect({ to: '/' });
    }
  },
  loader: async ({ params, context }) => {
    const { data } = await context.apolloClient.query({
      query: EventsDocument,
      variables: { first: 10, after: null, showPastEvents: true },
    });

    return {
      events: data.events.edges.map((edge) => edge.node),
      pageInfo: data.events.pageInfo,
    };
  },
});

function RouteComponent() {
  const data = Route.useLoaderData();
  return <EventLanding events={data.events} pageInfo={data.pageInfo} />;
}
